import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'letter-z-small', 'IconLetterZSmall', [["path",{"d":"M10 8h4l-4 8h4","key":"svg-0"}]]);